import { getAllRecords } from '../db/database';
import { getSizeInfo } from '../data/sizeReference';

/**
 * 导出申领记录为真实 .xlsx 文件
 */
export async function downloadExcel(operator = 'superadmin') {
  const XLSX = await import('xlsx');
  const records = await getAllRecords(operator);
  const headers = ['ID', '姓名', '部门', '性别', '尺码', '尺码名称', '颜色', '备注', '创建时间'];

  const rows = records.map((r) => {
    const info = getSizeInfo(r.size);
    return [
      r.id,
      r.name,
      r.department,
      r.gender,
      r.size,
      info.friendlyName,
      r.color || '',
      r.remark || '',
      new Date(r.created_at).toLocaleString('zh-CN'),
    ];
  });

  const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  sheet['!cols'] = [
    { wch: 6 },
    { wch: 12 },
    { wch: 14 },
    { wch: 8 },
    { wch: 8 },
    { wch: 14 },
    { wch: 16 },
    { wch: 16 },
    { wch: 20 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, '工装福利申领');

  const dateStr = new Date().toLocaleDateString('zh-CN').replace(/\//g, '-');
  XLSX.writeFile(workbook, `在途_工装福利申领_${dateStr}.xlsx`);
}
